import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import { omit } from 'lodash-es';
import { useContext as useRunRxContext } from '../../../run-rx/context';

const Context = createContext();

export const useLpkRunContext = () => useContext(Context);

export function Provider({ children }) {
  const {
    getError: runRxGetError,
    updateParam: runRxUpdateParam,
    getParam: runRxGetParam,
  } = useRunRxContext();

  const getError = useCallback(
    (name) => runRxGetError(`lpk.${name}`),
    [runRxGetError],
  );

  const getParam = useCallback(
    (name) => runRxGetParam(`lpk.${name}`),
    [runRxGetParam],
  );

  const updateParam = useCallback(
    (name, value) => runRxUpdateParam(`lpk.${name}`, value),
    [runRxUpdateParam],
  );

  const toggleNutrient = useCallback(
    (nutrient) => {
      const lpkParams = runRxGetParam('lpk');

      if (lpkParams[nutrient]) {
        runRxUpdateParam('lpk', omit(lpkParams, [nutrient]));
      } else {
        runRxUpdateParam('lpk', { ...lpkParams, [nutrient]: {} });
      }
    },
    [runRxGetParam, runRxUpdateParam],
  );

  const selectedNutrients = useMemo(
    () =>
      Object.fromEntries(
        Object.keys(runRxGetParam('lpk')).map((key) => [key, true]),
      ),
    [runRxGetParam],
  );

  const [yieldLoaded, setYieldLoaded] = useState();
  const [yieldQuickFill, setYieldQuickFill] = useState('');
  const [yieldCropGoals, setYieldCropGoals] = useState([
    { crop: '', value: '' },
    { crop: '', value: '' },
  ]);

  const state = useMemo(
    () => ({
      getError,
      selectedNutrients,
      toggleNutrient,
      getParam,
      updateParam,

      yieldLoaded,
      setYieldLoaded,
      yieldQuickFill,
      setYieldQuickFill,
      yieldCropGoals,
      setYieldCropGoals,
    }),
    [
      getError,
      selectedNutrients,
      toggleNutrient,
      getParam,
      updateParam,
      yieldLoaded,
      yieldQuickFill,
      yieldCropGoals,
    ],
  );

  return <Context.Provider value={state}>{children}</Context.Provider>;
}
